export interface LevelInfo {
  level: number;
  levelName: string;
  xpInLevel: number;
  xpToNext: number;
  progressPercent: number;
  minXp: number;
  maxXp: number;
}

// Noms des niveaux
const LEVEL_NAMES: Record<number, string> = {
  1: "Débutant",
  2: "Débutant",
  3: "Apprenti",
  4: "Apprenti",
  5: "Apprenti",
  6: "Confirmé",
  7: "Confirmé",
  8: "Confirmé",
  9: "Confirmé",
  10: "Confirmé",
  11: "Expert",
  12: "Expert",
  13: "Expert",
  14: "Expert",
  15: "Expert",
  16: "Maître",
  17: "Maître",
  18: "Maître",
  19: "Maître",
  20: "Maître",
};

// XP requis par niveau (100 XP par niveau)
const XP_PER_LEVEL = 100;

export function getLevelFromXp(xp: number): LevelInfo {
  const level = Math.floor(xp / XP_PER_LEVEL) + 1;
  const minXp = (level - 1) * XP_PER_LEVEL;
  const maxXp = level * XP_PER_LEVEL;
  const xpInLevel = xp - minXp;
  const xpToNext = maxXp - xp;
  const progressPercent = (xpInLevel / XP_PER_LEVEL) * 100;

  return {
    level,
    levelName: LEVEL_NAMES[Math.min(level, 20)] || "Légende",
    xpInLevel,
    xpToNext,
    progressPercent,
    minXp,
    maxXp,
  };
}

export function getLevelName(level: number): string {
  return LEVEL_NAMES[Math.min(level, 20)] || "Légende";
}